import { ContextMenuItem as CadArcContextMenuItem } from '@cad-arc';
import { ContextMenuItemView } from '@mark43/cad-api';
import { DisabledTitleWrapper } from './disabled-title-wrapper';

export function ContextMenuItem({
    contextMenuItemView,
    onSelect,
    dataPendoId,
    dataTrackId,
}: {
    contextMenuItemView: ContextMenuItemView;
    onSelect: () => void;
    dataPendoId?: string;
    dataTrackId?: string;
}): React.ReactElement {
    const { disabledTitle, isVisible, isEnabled, label } = contextMenuItemView;

    if (!isVisible) {
        return <></>;
    }

    return (
        <DisabledTitleWrapper disabledTitle={disabledTitle} isEnabled={isEnabled}>
            <CadArcContextMenuItem
                data-pendo-id={dataPendoId}
                data-track-id={dataTrackId}
                isDisabled={!isEnabled}
                onSelect={onSelect}
            >
                {label}
            </CadArcContextMenuItem>
        </DisabledTitleWrapper>
    );
}
